var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-nav"},_vm._l((_vm.list),function(data){return _c('span',{staticClass:"NoeDisplay-Bold",on:{"click":function($event){return _vm.scrollClick(data.id)}}},[_vm._v(" "+_vm._s(data.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }